import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { toast } from "sonner";

export default function Register() {
  const [form, setForm] = useState({
    name: "", email: "", phone: "", password: "",
    tax_id: "", customer_type: "final",
  });
  const [taxType, setTaxType] = useState("cpf"); // "cpf" ou "cnpj" (apenas rótulo)
  const [loading, setLoading] = useState(false);
  const { register } = useAuth();
  const navigate = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    if (form.password.length < 6) { toast.error("Senha deve ter ao menos 6 caracteres"); return; }
    if (!form.phone) { toast.error("Telefone é obrigatório para contato pós-pedido"); return; }
    setLoading(true);
    try {
      await register(form);
      toast.success("Conta criada!");
      navigate("/conta");
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Erro ao criar conta");
    } finally { setLoading(false); }
  };

  return (
    <div className="max-w-md mx-auto px-6 py-16" data-testid="register-page">
      <h1 className="font-display text-4xl text-[#49392F] text-center">Criar conta</h1>
      <p className="mt-3 text-center text-[13px] text-[#49392F]/70">Acompanhe seus pedidos, favoritos e benefícios exclusivos.</p>

      <form onSubmit={submit} className="mt-10 space-y-4">
        <input required placeholder="Seu nome completo" className="duo-input" value={form.name} onChange={(e) => setForm({...form, name: e.target.value})} data-testid="reg-name" />
        <input required type="email" placeholder="E-mail" className="duo-input" value={form.email} onChange={(e) => setForm({...form, email: e.target.value})} data-testid="reg-email" />
        <input required placeholder="WhatsApp com DDD (ex.: 11999999999)" className="duo-input" value={form.phone} onChange={(e) => setForm({...form, phone: e.target.value})} data-testid="reg-phone" />

        <div>
          <div className="text-[11px] tracking-[0.3em] uppercase text-[#49392F]/80 mb-2">Documento</div>
          <div className="flex gap-2 mb-2">
            <button type="button" onClick={() => setTaxType("cpf")} className={`flex-1 py-2 text-[12px] tracking-[0.2em] uppercase border ${taxType === "cpf" ? "bg-[#49392F] text-white border-[#49392F]" : "bg-white border-[#E8DCCB] text-[#49392F]"}`} data-testid="tax-type-cpf">CPF</button>
            <button type="button" onClick={() => setTaxType("cnpj")} className={`flex-1 py-2 text-[12px] tracking-[0.2em] uppercase border ${taxType === "cnpj" ? "bg-[#49392F] text-white border-[#49392F]" : "bg-white border-[#E8DCCB] text-[#49392F]"}`} data-testid="tax-type-cnpj">CNPJ</button>
          </div>
          <input
            placeholder={taxType === "cpf" ? "000.000.000-00" : "00.000.000/0000-00"}
            className="duo-input"
            value={form.tax_id}
            onChange={(e) => setForm({...form, tax_id: e.target.value})}
            data-testid="reg-tax-id"
          />
          <p className="text-[11px] text-[#49392F]/60 mt-1">Opcional. Necessário para emissão futura de nota fiscal.</p>
        </div>

        <div>
          <div className="text-[11px] tracking-[0.3em] uppercase text-[#49392F]/80 mb-2">Tipo de cliente</div>
          <div className="grid grid-cols-2 gap-2">
            <label className={`cursor-pointer p-3 border text-center ${form.customer_type === "final" ? "border-[#49392F] bg-[#E8DCCB]/40" : "border-[#E8DCCB] bg-white"}`}>
              <input type="radio" name="customer_type" value="final" checked={form.customer_type === "final"} onChange={() => setForm({...form, customer_type: "final"})} className="hidden" data-testid="customer-type-final" />
              <div className="text-[12px] tracking-[0.15em] uppercase text-[#49392F]">Consumidora final</div>
              <div className="text-[11px] text-[#49392F]/60 mt-1">Compro para uso pessoal ou presente</div>
            </label>
            <label className={`cursor-pointer p-3 border text-center ${form.customer_type === "revendedora" ? "border-[#49392F] bg-[#E8DCCB]/40" : "border-[#E8DCCB] bg-white"}`}>
              <input type="radio" name="customer_type" value="revendedora" checked={form.customer_type === "revendedora"} onChange={() => setForm({...form, customer_type: "revendedora"})} className="hidden" data-testid="customer-type-revendedora" />
              <div className="text-[12px] tracking-[0.15em] uppercase text-[#49392F]">Revendedora</div>
              <div className="text-[11px] text-[#49392F]/60 mt-1">Compro para revender</div>
            </label>
          </div>
        </div>

        <input required type="password" minLength={6} placeholder="Senha (mín. 6 caracteres)" className="duo-input" value={form.password} onChange={(e) => setForm({...form, password: e.target.value})} data-testid="reg-password" />
        <button disabled={loading} className="duo-btn duo-btn-primary w-full" data-testid="reg-submit">
          {loading ? "Criando conta..." : "Criar conta"}
        </button>
      </form>

      <p className="mt-6 text-center text-[12px] text-[#49392F]/70">
        Já tem uma conta? <Link to="/login" className="link-elegant text-[#49392F]">Entrar</Link>
      </p>
    </div>
  );
}
